import { render, staticRenderFns } from "./TableRowPercentNewPatientsOnScit.vue?vue&type=template&id=3743e8d1&lang=pug&"
import script from "./TableRowPercentNewPatientsOnScit.vue?vue&type=script&lang=js&"
export * from "./TableRowPercentNewPatientsOnScit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3743e8d1')) {
      api.createRecord('3743e8d1', component.options)
    } else {
      api.reload('3743e8d1', component.options)
    }
    module.hot.accept("./TableRowPercentNewPatientsOnScit.vue?vue&type=template&id=3743e8d1&lang=pug&", function () {
      api.rerender('3743e8d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowPercentNewPatientsOnScit.vue"
export default component.exports